__turbopack_context__.v({
  "group": "SidebarNavigation-module__BG9Vaq__group",
  "heading": "SidebarNavigation-module__BG9Vaq__heading",
  "link": "SidebarNavigation-module__BG9Vaq__link",
  "navigation": "SidebarNavigation-module__BG9Vaq__navigation",
  "sidebar": "SidebarNavigation-module__BG9Vaq__sidebar",
  "surface": "SidebarNavigation-module__BG9Vaq__surface",
});
